import { createAuth0 } from '@auth0/auth0-vue'

export default createAuth0({
  domain: import.meta.env.VITE_AUTH0_DOMAIN,
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
  cacheLocation: 'localstorage',
  authorizationParams: {
    redirect_uri: window.location.origin + '/callback',
    audience: import.meta.env.VITE_AUTH0_AUDIENCE,
    ...(import.meta.env.VITE_AUTH0_CONNECTION
      ? { connection: import.meta.env.VITE_AUTH0_CONNECTION }
      : {})
  }
})
